import { baseApi } from '@/config/axios';
import { store } from '@/config/store';
import {
  CustomerInfoApiParams,
  CustomerInfoApiResponse,
  UpdateEmailApiParams,
  UpdateEmailApiResponse,
  UpdatePasswordApiParams,
  UpdatePasswordApiResponse,
} from '@/types/api/customerApi';
import {
  UpdateWarrantyCustomerParams,
  UpdateWarrantyCustomerResponse,
} from '@/types/api/warrantyApi';
import {
  registerCustomerInfoRestrictionRequest,
  startPrepaidRestrictionRequest,
} from '@/utils/prepaidRestrictionRequest';

// 5.基礎情報取得
// テナント切り替え中は切り替え先法人IDを併せて送り、サービス導入状況の判定に使わせる。
// 呼び出し箇所が多いため個別に渡さず、ここで store から解決して付与する。
export const customerInfoApi = (
  params: CustomerInfoApiParams,
): Promise<CustomerInfoApiResponse> => {
  const selectedTenantId = store.state.selectedTenant?.m_affiliate_id ?? null;
  const requestId = startPrepaidRestrictionRequest();
  return baseApi
    .get('v1/customer/info', {
      params: {
        ...params,
        ...(store.state.selectedTenant
          ? { switch_m_affiliate_id: store.state.selectedTenant.m_affiliate_id }
          : {}),
      },
    })
    .then((response: CustomerInfoApiResponse) => {
      registerCustomerInfoRestrictionRequest(response.data.customer, {
        customerId: params.m_customer_id,
        selectedTenantId,
        requestId,
      });
      return response;
    });
};

// 26. パスワード変更
export const updatePasswordApi = (
  params: UpdatePasswordApiParams,
): Promise<UpdatePasswordApiResponse> =>
  baseApi.put('v1/customer/password-change', { ...params });

// 75. メールアドレス変更処理
export const updateEmailApi = (
  params: UpdateEmailApiParams,
): Promise<UpdateEmailApiResponse> =>
  baseApi.put('v1/customer/email-change', { ...params });

// 21. お客様情報更新
export const updateCustomerApi = (
  params: UpdateWarrantyCustomerParams,
): Promise<UpdateWarrantyCustomerResponse> =>
  baseApi.put('v1/customer', params);
